import { render, staticRenderFns } from "./CollapseComponentList.vue?vue&type=template&id=710efaae&"
import script from "./CollapseComponentList.vue?vue&type=script&lang=ts&"
export * from "./CollapseComponentList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports